import React, { useState } from "react";
import moment from "moment";
import classNames from "classnames";

import { useOutsideClickHook } from "utils/outsideClick";
import { getIceVehicleTemplate, getElectricVehicleTemplate, getHybridVehicleTemplate } from "utils/transportation";
import { useStateSelector } from "utils/field";
import { createKeyboardShortcut } from "utils/keyboardShortcuts";

import { DropDown } from "components/Input/Select";

import classes from "./style.module.scss";

import Add from "assets/images/icons/JSX/Add";

export default ({ accessor, change }) => {
    const [open, setToggleOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);

    const ref = useOutsideClickHook(() => setToggleOpen(false));

    const vehicles = useStateSelector(`model.modelData.transportation.vehicles`) || {};

    const handleAddVehicle = (value) => {
        const key = `${accessor}.vehicles.vehicle${moment().format("YYYYMMDDHHmmssSS")}`;
        let valueToAdd = null;

        // Calculate the next available system number
        const existingVehicleNumbers = Object.values(vehicles).map((vehicle) => vehicle.systemNumber);
        const nextSystemNumber = existingVehicleNumbers.length > 0 ? Math.max(...existingVehicleNumbers) + 1 : 1;

        if (value === "ice") {
            valueToAdd = {
                ...getIceVehicleTemplate(),
                type: value,
                systemNumber: nextSystemNumber,
            };
        } else if (value === "ev") {
            valueToAdd = {
                ...getElectricVehicleTemplate(),
                type: value,
                systemNumber: nextSystemNumber,
            };
        } else if (value === "hybrid") {
            valueToAdd = {
                ...getHybridVehicleTemplate(),
                type: value,
                systemNumber: nextSystemNumber,
            };
        }

        if (valueToAdd) {
            change(key, valueToAdd);
        }

        setSelectedValue(null);
        setToggleOpen(false);
    };

    const handleDropDownItemClick = (value) => {
        setSelectedValue(value);
        handleAddVehicle(value);
    };

    const handleToggleDropDown = () => {
        setToggleOpen(!open);
    };

    //TODO: re-enable hybrid when we can better communicate how results are calculated (results seem odd when there's a small commute and no gas consumption)
    const options = [
        { value: "ice", label: "Internal Combustion Engine Vehicle" },
        { value: "ev", label: "Electric Vehicle" },
        { value: "hybrid", label: "Plug-in Hybrid Vehicle" },
    ];

    const canAddVehicle = Object.keys(vehicles).length < 8;

    const handleChange = (value) => {
        setSelectedValue(value);
        handleAddVehicle(value);
    };

    return (
        <div className={classes.addComponent} ref={ref}>
            <div
                className={classNames(classes.addText, {[classes.open]: open})}
                onClick={handleToggleDropDown}
                {...createKeyboardShortcut({ onKeyDown: handleToggleDropDown, dropDownFocus: true})}
            >
                {canAddVehicle ? "Add Vehicle" : "Vehicle Limit Reached"}
                {canAddVehicle && <Add />}
            </div>
            {canAddVehicle && (
                <DropDown
                    className={classes.dropDown}
                    options={options}
                    selected={selectedValue}
                    toggleOpen={handleToggleDropDown}
                    open={open}
                    onChange={handleChange}
                    onItemClick={handleDropDownItemClick}
                />
            )}
        </div>
    );
};
